module.exports = __webpack_public_path__ + "img/cloud-plus.9839ab0d.svg";